import {ReactNode} from 'react';

import {Route} from '../types/routes';
import {SiteFooter} from './SiteFooter';
import {SiteHeader} from './SiteHeader';

export const Page = ({children, route}: {children: ReactNode; route: Route}) => (
  <>
    <SiteHeader route={route} />
    <main className="nx-page overflow-clip">{children}</main>
    <SiteFooter />
  </>
);
